document.addEventListener('DOMContentLoaded', function() {
    const listItems = document.querySelectorAll('.toggle-checkbox');
    
    listItems.forEach(function(li) {
        li.addEventListener('click', function(event) {
            // Prevent the default action if the label is clicked
            if (event.target.tagName !== 'INPUT') {
                const checkbox = li.querySelector('input[type="checkbox"]');
                checkbox.checked = !checkbox.checked;
                const changeEvent = new Event('change', { bubbles: true });
                checkbox.dispatchEvent(changeEvent);
            }
        });
    });
});

$(document).ready(function() {
    const currentUrl = window.location.href;
    // console.log(currentUrl);
    const productsPerPage = 30; // Number of products per page

    // Total number of products available
    const productsInnerWrapper = document.getElementById('products_inner_wrapper');
    const totalProducts = parseInt(productsInnerWrapper.getAttribute('data-total-product-count'), 10);
    const totalPages = Math.ceil(totalProducts / productsPerPage);
    let lastLoadedPage = 1;
    const urlParams = new URLSearchParams(window.location.search);
    const initialPages = parseInt(urlParams.get('pages')) || 1;
    let isLoading = false;
    const productsByPage = {};
    let products = [];
    let filteredProducts = []
    let productsFetched = false;
    let productFiltering = false;
    // console.log(`Total products: ${totalProducts}, Total pages: ${totalPages}, Initial pages: ${initialPages}`);

    function sortProducts(productsToSort, criteria) {
        // console.log(productsToSort);
        return productsToSort.sort((a, b) => {
            switch (criteria) {
                case 'title-ascending':
                    return a.title.localeCompare(b.title);
                case 'title-descending':
                    return b.title.localeCompare(a.title);
                case 'price-ascending':
                    return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);
                case 'price-descending':
                    return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price);
                case 'created-ascending':
                    return new Date(a.created_at) - new Date(b.created_at);
                case 'created-descending':
                    return new Date(b.created_at) - new Date(a.created_at);
                default:
                    return 0; // No sorting
            }
        });
    }

    // Event listener for the sort select element
    $('#SortBy').on('change', function() {
        const sortBy = $(this).val();
        // console.log('Sort by:', sortBy);
        // console.log('products: ', products);
        // console.log('filteredProducts: ', filteredProducts);
        // console.log('productFiltering: ', productFiltering);
        let sortedProducts;
        // Sort the products
        if (productFiltering) {
            sortedProducts = sortProducts(filteredProducts, sortBy);
        }else{
            sortedProducts = sortProducts(products, sortBy);
        }
        // console.log(sortedProducts)

        // Display sorted products
        displayProducts(sortedProducts);
    });
    function generateProductHTML(product) {
        let compareAtPrice =  product.variants[0].compare_at_price ? `<span class="price-old"> £${product.variants[0].compare_at_price} </span>` : "";
        return `<div id="product-${product.variants[0].id}" class="product product-layout grid__item grid__item--collection-template col-xl-3 col-lg-4 col-md-4 col-sm-4 col-xs-6 grid_4" data-price="${product.variants[0].price}">
      <span class="d-none">£${product.variants[0].price}</span>
      <div class="product-item" data-id="product-${product.variants[0].id}">
        <div class="product-item-container grid-view-item">
          <div class="left-block">
            <div class="product-image-container product-image">
              <a class="grid-view-item__link image-ajax" href="/products/${product.handle}">
                <img class="img-responsive s-img lazyautosizes lazyloaded" data-sizes="auto" src="${product.images && product.images.length > 0 ? product.images[0].src : 'https://cdn.shopify.com/s/files/1/0550/7556/9815/files/no_photo_guitar_2.webp?v=1717164216'}" data-src="${product.images && product.images.length > 0 ? product.images[0].src : 'https://cdn.shopify.com/s/files/1/0550/7556/9815/files/no_photo_guitar_2.webp?v=1717164216'}" alt="${product.title}" sizes="40px">
              </a>
              <div class="quickview-button">
                <a class="quickview iframe-link visible-lg btn_df" href="javascript:void(0)" data-variants_id="${product.variants[0].id}" data-toggle="modal" data-target="#myModal" data-id="${product.handle}" title="Quick View"><span>Quick View</span></a>
              </div>
              <div class="button-link">
                <div class="btn-button add-to-cart add-sellect">
                  <a class="btn_df grl" href="/products/${product.handle}" title="Select options"><i class="fa fa-shopping-basket"></i><span class="hidden-xs hidden-sm hidden-md">Add To Cart</span></a>
                </div>
                <div class="product-addto-links">
                  <a class="btn_df btnProduct wishlist" href="/account/login" title="Wishlist">
                    <icon class="qty_ico">🤍</icon>
                    <span class="hidden-xs hidden-sm hidden-md">Wishlist</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="right-block">
            <div class="caption">
              <div class="custom-reviews"></div>
              <h3 class="title-product text-truncate fs14"><a class="product-name" href="/products/${product.handle}">${product.title}</a></h3>
              <div class="price">
                <span class="visually-hidden">Regular price</span>
                <span class="price-new">£${product.variants[0].price}</span>
                ${compareAtPrice}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    }
    function removeAllChildren(element) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }
    function clearProducts() {
        removeAllChildren(productsInnerWrapper);
    }

    function fetchAllProducts() {
            isLoading = true;
            let allRequests = [];

            for (let page = 1; page <= totalPages; page++) {
                allRequests.push($.ajax({
                    url: `${getBaseUrl(currentUrl)}/products.json?page=${page}`,
                    type: 'GET',
                    dataType: 'json'
                }));
            }

            return $.when(...allRequests).then(function(...responses) {
                let availableProducts = [];

                // Handle the case when there's only one page
                if (allRequests.length === 1) {
                    responses = [responses];
                }

                responses.forEach(response => {
                    const data = response[0]; // Extract data if request was successful
                    if (data && data.products) {
                        availableProducts = availableProducts.concat(filterAvailableProducts(data.products));
                    } else {
                        console.error('Invalid response data:', response);
                    }
                });

                products = availableProducts; // Populate products after fetching
                productsFetched = true;
                isLoading = false;
                // console.log(`Fetched products: ${products.length}`);
                return availableProducts;
            }).fail(function() {
                console.error('Error fetching one or more pages of products.');
                isLoading = false;
                return [];
            });
        }


    // Function to fetch a page of products
    function fetchPage(page) {
        return $.ajax({
            url: `${getBaseUrl(currentUrl)}/products.json?page=${page}`,
            type: 'GET',
            dataType: 'json'
        }).done(function(response) {
            if (response && response.products) {
                productsByPage[page] = filterAvailableProducts(response.products);
                lastLoadedPage = page;
                products.concat(productsByPage[page])
            } else {
                console.error(`Invalid response for page ${page}:`, response);
            }
        }).fail(function() {
            console.error(`Error fetching page ${page} of products.`);
        });
    }

    // Orchestrator function to manage fetching and displaying products
    function loadAndDisplayPages(pages) {
        isLoading = true;
        let allRequests = [];
        for (let page = 1; page <= pages; page++) {
            allRequests.push(fetchPage(page));
        }

        $.when(...allRequests).done(function() {
            clearProducts()
            displayAllProducts();
            if (pages > 1) {
                updateUrl(pages);
            }
            isLoading = false;
        });
    }

    // Function to display all fetched products in order
    function displayAllProducts() {
        let allProducts = [];
        const pages = Object.keys(productsByPage).sort((a, b) => a - b);
        pages.forEach(page => {
            allProducts = allProducts.concat(productsByPage[page]);
            products = products.concat(productsByPage[page]);
        });
        displayProducts(allProducts);
    }

    function getBaseUrl(url) {
        const parsedUrl = new URL(url);
        parsedUrl.search = '';
        return parsedUrl.href;
    }

    function displayAllFetchedProducts(allProducts) {
        displayProducts(allProducts);
    }

    function updateUrl(page) {
        const newUrl = `${window.location.pathname}?pages=${page}`;
        history.pushState(null, '', newUrl);
    }

    // Intersection Observer to load more products when bottom is in view
    // const observer = new IntersectionObserver((entries) => {
    //     if(!productFiltering){
    //         if (entries[0].isIntersecting) {
    //             if (!isLoading) {
    //                 isLoading = true;
    //                 if (lastLoadedPage < totalPages) {
    //                     fetchPage(lastLoadedPage + 1).done(function() {
    //                         displayAllProducts();
    //                         updateUrl(lastLoadedPage);
    //                         isLoading = false;
    //                     });
    //                 }
    //             }
    //         }
    //     }
    // }, { threshold: 1.0 });

    // Attach the observer to the bottom of the #products-container
    // observer.observe(document.querySelector('#products_end'));





    // Load the initial set of pages
    loadAndDisplayPages(initialPages);

    function filterAvailableProducts(products) {
        return products.filter(product => product.variants.some(variant => variant.available));
    }

    function displayProducts(products, append = false) {
        if (!append) {
            $(productsInnerWrapper).empty();
        }
        products.forEach(product => {
            const productHTML = generateProductHTML(product);
            productsInnerWrapper.innerHTML += productHTML;
        });
    }

    function filterProducts() {
        productFiltering = true;
        const selectedTags = Array.from(document.querySelectorAll('.filter-tags input:checked')).map(checkbox => checkbox.value);
// console.log('productsFetched? ', productsFetched)
// console.log('products: ', products)

        if (selectedTags.length > 0) {
            if (!productsFetched) {
                fetchAllProducts().then(fetchedProducts => {
                    products = fetchedProducts;
                    applyFilter(selectedTags);
                    // console.log(products)
                });
            } else {
                applyFilter(selectedTags);
            }
        } else {
            resetFilter();
        }
    }

    // Function to apply the filter to the products
    function applyFilter(selectedTags) {
        const lowercasedSelectedTags = selectedTags.map(tag => tag.toLowerCase());

        filteredProducts = products.filter(product =>
            lowercasedSelectedTags.every(tag =>
                product.tags.map(productTag =>
                    productTag
                        .toLowerCase()
                        .replace(/£/g, '') // Remove £ signs
                        .replace(/\s+/g, '-') // Replace multiple spaces with a single dash
                        .replace(/-+/g, '-') // Replace multiple dashes with a single dash
                ).includes(tag)
            )
        );
        clearProducts();
        updateCheckboxes(filteredProducts);
        displayProducts(filteredProducts);
        // console.log('Filtered Products:', filteredProducts);
    }

    // Function to update checkboxes based on filtered products
    function updateCheckboxes(filteredProducts) {
        const allTags = filteredProducts.flatMap(product =>
            product.tags.map(tag => tag.toLowerCase().replace(/\s+/g, '-'))
        );
        const uniqueTags = [...new Set(allTags)];

        document.querySelectorAll('.filter-tags input[type="checkbox"]').forEach(checkbox => {
            if (uniqueTags.includes(checkbox.value.toLowerCase())) {
                checkbox.parentElement.classList.remove('disabled-checkbox');
                checkbox.disabled = false;
            } else {
                checkbox.parentElement.classList.add('disabled-checkbox');
                checkbox.disabled = true;
            }
        });
    }

    // Function to reset the filter and checkboxes
    function resetFilter() {
        productFiltering = false;
        document.querySelectorAll('.filter-tags input[type="checkbox"]').forEach(checkbox => {
            checkbox.parentElement.classList.remove('disabled-checkbox');
            checkbox.disabled = false;
        });
        displayProducts(products);
        // console.log('No checkboxes selected');
    }
    document.getElementById("loadMoreButton").addEventListener("click", function(){
        if (!isLoading) {
            isLoading = true;
            if (lastLoadedPage < totalPages) {
                fetchPage(lastLoadedPage + 1).done(function() {
                    displayAllProducts();
                    updateUrl(lastLoadedPage);
                    isLoading = false;
                });
            }
        }
    });
    // Event listener for checkboxes
    document.querySelectorAll('.filter-tags input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', filterProducts);
    });
});
